import BaseService from '@/shared/services/base.service';

class FireBaseService extends BaseService {
  async subscribeToPushNotification(fcmToken) {
    try {
      const response = await this.repository.subscribeToPushNotification(fcmToken);
      return this.handleResponse(response);
    } catch (error) {
      console.warn('[AuthService] Failed to subscribe to push notifications:', error.message);
      return {};
    }
  }

  async unsubscribeFromPushNotification(fcmToken) {
    try {
      const response = await this.repository.unsubscribeFromPushNotification(fcmToken);
      return this.handleResponse(response);
    } catch (error) {
      console.warn('[AuthService] Failed to unsubscribe from push notifications:', error.message);
      return {};
    }
  }
}

export default new FireBaseService('firebase');
